(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__freeShippingPopupReady) return;
    window.__freeShippingPopupReady = true;

    function getWrapper(el) {
      var direct = el.closest('.free-shipping__bar-wrapper');
      if (direct) return direct;
      var container = el.closest('.free-shipping');
      return container ? container.querySelector('.free-shipping__bar-wrapper') : null;
    }

    function closePopup(wrapper) {
      if (!wrapper) return;
      var popup = wrapper.querySelector('[data-marker-popup]');
      if (!popup) return;
      popup.hidden = true;
      wrapper.querySelectorAll('[data-marker-popup-trigger]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function closeAllPopups() {
      document.querySelectorAll('.free-shipping__bar-wrapper [data-marker-popup]').forEach(function (p) {
        if (!p.hidden) closePopup(getWrapper(p));
      });
    }

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-marker-popup-close]');
      if (closeBtn) {
        e.stopPropagation();
        closePopup(getWrapper(closeBtn));
        return;
      }

      var trigger = e.target.closest('[data-marker-popup-trigger]');
      if (trigger) {
        e.stopPropagation();
        var type = trigger.getAttribute('data-marker-popup-trigger');
        var wrapper = getWrapper(trigger);
        var popup = wrapper.querySelector('[data-marker-popup]');
        var contentEl = wrapper.querySelector('[data-marker-popup-content]');
        var template = wrapper.querySelector('[data-popup-content="' + type + '"]');

        if (!template) return;

        var isAlreadyOpen = !popup.hidden && trigger.getAttribute('aria-expanded') === 'true';
        closePopup(wrapper);
        if (isAlreadyOpen) return;

        contentEl.innerHTML = '';
        contentEl.appendChild(template.content.cloneNode(true));
        trigger.setAttribute('aria-expanded', 'true');
        popup.hidden = false;
        return;
      }

      if (!e.target.closest('.free-shipping')) {
        closeAllPopups();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPopups();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
